/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ReplacementInputs */

const en_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replacement`)
};

const fr_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacement`)
};

const de_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersatz`)
};

const it_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituzione`)
};

const ru_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замена`)
};

const es_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazo`)
};

const zh_cn2_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`替代品`)
};

const ja_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交換`)
};

const hi_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिस्थापन`)
};

const pt_pt2_replacement = /** @type {(inputs: ReplacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituição`)
};

/**
* | output |
* | --- |
* | "Replacement" |
*
* @param {ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replacement = /** @type {((inputs?: ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_replacement(inputs)
	if (locale === "de") return de_replacement(inputs)
	if (locale === "it") return it_replacement(inputs)
	if (locale === "ru") return ru_replacement(inputs)
	if (locale === "es") return es_replacement(inputs)
	if (locale === "zh-CN") return zh_cn2_replacement(inputs)
	if (locale === "ja") return ja_replacement(inputs)
	if (locale === "hi") return hi_replacement(inputs)
	if (locale === "pt-PT") return pt_pt2_replacement(inputs)
	return en_replacement(inputs)
});